import React, { useState, useEffect, useRef } from "react";
import authService from "../../api-authorization/AuthorizeService";
import { useNavigate } from "react-router-dom";
import i18n from "i18next";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import { baseUrl } from "../../../helpers/constants";
import useWindowSize from "../../../helpers/useWindowSize";
import {
  Accordion,
  TabList,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Tab,
  Button,
  Divider,
  Link,
} from "@fluentui/react-components";
import {
  AirplaneTakeOffFilled,
  AirplaneTakeOffRegular,
  ArrowCircleUp24Filled,
  ArrowCircleUp24Regular,
  BoxFilled,
  BoxMultipleSearchFilled,
  BoxMultipleSearchRegular,
  BoxRegular,
  BoxSearch24Filled,
  BoxSearch24Regular,
  ChatBubblesQuestionFilled,
  ChatBubblesQuestionRegular,
  ChevronDownRegular,
  DataPie24Filled,
  DataPie24Regular,
  DeveloperBoardSearch24Filled,
  DeveloperBoardSearch24Regular,
  Document24Filled,
  Document24Regular,
  DocumentPersonFilled,
  DocumentPersonRegular,
  FolderMail24Filled,
  FolderMail24Regular,
  FolderPerson24Filled,
  FolderPerson24Regular,
  FolderSearch24Filled,
  FolderSearch24Regular,
  HatGraduationFilled,
  HatGraduationRegular,
  HatGraduationSparkle24Filled,
  HatGraduationSparkle24Regular,
  HomeFilled,
  HomeRegular,
  Info24Filled,
  Info24Regular,
  LibraryFilled,
  LibraryRegular,
  Mail24Filled,
  Mail24Regular,
  MailSettingsFilled,
  MailSettingsRegular,
  MegaphoneFilled,
  MegaphoneRegular,
  PeopleTeamFilled,
  PeopleTeamRegular,
  Person24Filled,
  Person24Regular,
  PersonEditFilled,
  PersonEditRegular,
  PersonFilled,
  SettingsFilled,
  SettingsRegular,
  ShieldFilled,
  ShieldRegular,
  ShoppingBagAddFilled,
  ShoppingBagAddRegular,
  ShoppingBagFilled,
  ShoppingBagRegular,
  WrenchScrewdriverFilled,
  WrenchScrewdriverRegular,
} from "@fluentui/react-icons";
import NavMenuEditUserDialog from "./NavMenuShowUser";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import RequireAuth from "../../api-authorization/RequireAuth";

interface INavMenuProps {
  phoneView: boolean;
  panelOpen?: boolean;
  onNavigate?: any;
  roles: any;
  user: IAppUserDto | undefined;
}

function NavMenu(props: INavMenuProps) {
  const [selectedTab, setSelectedTab] = useState<string>("/");
  const [openAccordionItems, setOpenAccordionItems] = useState<string>();
  useEffect(() => {
    if (selectedTab != "/") {
      links.forEach((y) => {
        if (y.links.find((x) => x.key == selectedTab)?.key == selectedTab)
          setOpenAccordionItems(y.name);
      });
    }
  }, [selectedTab]);
  const navigate = useNavigate();

  function onNavigated(link: string) {
    if (link != "/confist") {
      navigate(link);
      props.onNavigate(link);
    }
  }

  const adminLinks = {
    name: "Admin",
    links: [
      /* {
        key: "/admin/users",
        name: i18n.t<string>("users"),
        iconRegular: <Person24Regular color= {props.phoneView == true ? "#ff6600": ""} />,
        iconFilled: <Person24Filled color= {props.phoneView == true ? "#ff6600": ""} />,
        url: "",
        target: "",
      }, */
      {
        key: "/admin/emailtemplates",
        name: i18n.t<string>("emailTemplates"),
        iconRegular: (
          <FolderMail24Regular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <FolderMail24Filled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      },
      {
        key: "/admin/logging",
        name: "Logging",
        iconRegular: (
          <FolderSearch24Regular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <FolderSearch24Filled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      },
      {
        key: "/admin/documentaccesslogs",
        name: i18n.t<string>("documentAccessLogs"),
        iconRegular: (
          <Info24Regular color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        iconFilled: (
          <Info24Filled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      },
    ],
  };

  const vertriebsLinks = {
    name: "Vertrieb",
    links: [
      {
        key: "/sales/configurator",
        name: i18n.t<string>("configuratorRequests"),
        iconRegular: (
          <MailSettingsRegular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <MailSettingsFilled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      },
      {
        key: "/sales/requests",
        name: i18n.t<string>("processRequests"),
        iconRegular: (
          <BoxSearch24Regular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <BoxSearch24Filled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      },
      {
        key: "/sales/products",
        name: i18n.t<string>("products"),
        iconRegular: (
          <BoxRegular color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        iconFilled: (
          <BoxFilled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      },
      {
        key: "/sales/parts",
        name: i18n.t<string>("parts"),
        iconRegular: (
          <ShoppingBagAddRegular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <ShoppingBagAddFilled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      },
      {
        key: "/sales/documents",
        name: i18n.t<string>("documents"),
        iconRegular: (
          <Document24Regular color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        iconFilled: (
          <Document24Filled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      },
      {
        key: "/sales/AerospaceNorm",
        name: i18n.t<string>("aerospaceNorm"),
        iconRegular: (
          <AirplaneTakeOffRegular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <AirplaneTakeOffFilled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      },
    ],
  };

  const vertriebsAdminLinks = {
    name: "Vertriebsadmin",
    links: [
      {
        key: "/sales/usersDocuments",
        name: i18n.t<string>("userDocuments"),
        iconRegular: (
          <FolderPerson24Regular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <FolderPerson24Filled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      },
      {
        key: "/sales/users",
        name: i18n.t<string>("users"),
        iconRegular: (
          <Person24Regular color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        iconFilled: (
          <Person24Filled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      },
      {
        key: "/sales/emails",
        name: "E-Mails",
        iconRegular: (
          <Mail24Regular color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        iconFilled: (
          <Mail24Filled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      },
      {
        key: "/sales/RoleRequests",
        name: i18n.t<string>("roleRequests"),
        iconRegular: (
          <DeveloperBoardSearch24Regular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <DeveloperBoardSearch24Filled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      },
      {
        key: "/salesadmin/overtakeproductrequests",
        name: i18n.t<string>("overtakeProductRequests"),
        iconRegular: (
          <ArrowCircleUp24Regular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <ArrowCircleUp24Filled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      },
      {
        key: "/salesadmin/kpi",
        name: "KPI",
        iconRegular: (
          <DataPie24Regular color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        iconFilled: (
          <DataPie24Filled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      },
    ],
  };

  function getLinks(roles: string[]) {
    let navLinks = [
      {
        name: "Module",
        links: [
          {
            key: "/",
            name: i18n.t<string>("homePage"),
            iconRegular: (
              <HomeRegular color={props.phoneView == true ? "#ff6600" : ""} />
            ),
            iconFilled: (
              <HomeFilled color={props.phoneView == true ? "#ff6600" : ""} />
            ),
            url: "",
            target: "",
          },
        ],
      },
      {
        name: "default",
        links: [
          {
            key: "/termsofuse",
            name: i18n.t<string>("terms-of-use"),
            iconRegular: (
              <DocumentPersonRegular
                color={props.phoneView == true ? "#ff6600" : ""}
              />
            ),
            iconFilled: (
              <DocumentPersonFilled
                color={props.phoneView == true ? "#ff6600" : ""}
              />
            ),
            url: "",
            target: "",
          },
          {
            iconRegular: (
              <ShieldRegular
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            iconFilled: (
              <ShieldFilled
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            name: i18n.t<string>("privacy-policy"),
            key: "/privacypolicy",
          },
          {
            iconRegular: (
              <MegaphoneRegular
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            iconFilled: (
              <MegaphoneFilled
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            name: i18n.t<string>("imprint"),
            key: "/imprint",
          },
          /* {
            iconRegular: <DismissRegular fontSize={24} />,
            iconFilled: <DismissFilled color= {props.phoneView == true ? "#ff6600": ""} fontSize={24} />,
            text: i18n.t<string>("test"),
            navigate: "/mediathek",
          }, */
          {
            iconRegular: (
              <ChatBubblesQuestionRegular
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            iconFilled: (
              <ChatBubblesQuestionFilled
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            name: "FAQ",
            key: "/faq",
          },
        ],
      },
      {
        name: "UserOptions",
        links: [
          {
            iconRegular: (
              <ShoppingBagRegular
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            iconFilled: (
              <ShoppingBagFilled
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            name: i18n.t<string>("bedarfe"),
            key: "/account/requirements",
          },
          {
            iconRegular: (
              <PeopleTeamRegular
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            iconFilled: (
              <PeopleTeamFilled
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            name: i18n.t<string>("my-teams"),
            key: "/account/myteams",
          },
          {
            iconRegular: (
              <PersonEditRegular
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            iconFilled: (
              <PersonEditFilled
                color={props.phoneView == true ? "#ff6600" : ""}
                fontSize={24}
              />
            ),
            name: i18n.t<string>("manageAccount"),
            key: "/account",
          },
        ],
      },
    ];

    if (props.roles && roles.includes("Configurator")) {
      navLinks[0].links.push({
        key: "/configuratorst",
        name: "L.SP3 Configurator",
        iconRegular: (
          <SettingsRegular color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        iconFilled: (
          <SettingsFilled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      });
    }

    // Quick Finder
    if (roles && roles.includes("Catalog")) {
      navLinks[0].links.push({
        key: "/quickfinder",
        name: "Quick Finder",
        iconRegular: (
          <BoxMultipleSearchRegular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <BoxMultipleSearchFilled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      });
    }

    if (roles && roles.includes("Toolbox")) {
      navLinks[0].links.push({
        key: "/mytoolbox",
        name: "My Toolbox",
        iconRegular: (
          <WrenchScrewdriverRegular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <WrenchScrewdriverFilled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      });
    }

    if (roles && roles.includes("Academy")) {
      navLinks[0].links.push({
        key: "/academy",
        name: "Academy",
        iconRegular: (
          <HatGraduationRegular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <HatGraduationFilled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      });
    }

    if (roles && roles.includes("Partner")) {
      navLinks[0].links.push({
        key: "/partnerlounge",
        name: "Partner Lounge",
        iconRegular: (
          <WrenchScrewdriverRegular
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        iconFilled: (
          <WrenchScrewdriverFilled
            color={props.phoneView == true ? "#ff6600" : ""}
          />
        ),
        url: "",
        target: "",
      });
    }

    // Add Admin Links if User is Admin
    if (roles && roles.includes("Admin")) {
      navLinks.push(adminLinks);
    }

    if (roles && roles.includes("Vertrieb")) {
      if (props.roles.includes("AcademyAdmin")) {
        vertriebsLinks.links.push({
          key: "/academyadmin",
          name: "Academy-Admin",
          iconRegular: (
            <HatGraduationSparkle24Regular
              color={props.phoneView == true ? "#ff6600" : ""}
            />
          ),
          iconFilled: (
            <HatGraduationSparkle24Filled
              color={props.phoneView == true ? "#ff6600" : ""}
            />
          ),
          url: "",
          target: "",
        });
      }
      navLinks.push(vertriebsLinks);
    }

    if (roles && roles.includes("Vertriebsadmin")) {
      navLinks.push(vertriebsAdminLinks);
    }

    if (!baseUrl.includes("www.luebbering-digital.com")) {
      navLinks[0].links.push({
        key: "/mediathek",
        name: "Mediathek",
        iconRegular: (
          <LibraryRegular color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        iconFilled: (
          <LibraryFilled color={props.phoneView == true ? "#ff6600" : ""} />
        ),
        url: "",
        target: "",
      });
    }
    return navLinks;
  }

  const links = getLinks(props.roles);

  const windowSize = useWindowSize();
  const ref = useRef<any>(undefined);

  /* useEffect(() => {
    if (props.panelOpen) {
      authService.getUser().then((user) => {
        if (user) {
        } else {
        }
      });
    }
  }, [props.panelOpen]); */

  useEffect(() => {
    if (window.location.pathname) {
      if (window.location.pathname == "/academy/catalog") {
        setSelectedTab("/academy");
      } else {
        setSelectedTab(window.location.pathname);
      }
    }
  }, [window.location.pathname]);

  return (
    <>
      <>
        {/* {props.phoneView == false && (
          /*Lübbering Logo
          <StackShim horizontalAlign="center">
            <Link
              onClick={() => {
                navigate("/");
              }}
            >
              <img
                alt=""
                src={`${baseUrl}/LUEBBERING_DIGITAL_512X512PX.PNG`}
                height={55}
              />
            </Link>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
          </StackShim>
        )} */}

        {props.phoneView == true && (
          <>
            {/* Benutzer Icon oder Login */}
            <StackShim horizontalAlign="center">
              {props.user && <NavMenuEditUserDialog user={props.user} />}
              {!props.user && (
                <Button
                  onClick={() => {
                    navigate("/account/login");
                    props.onNavigate();
                  }}
                  icon={<PersonFilled />}
                  appearance="transparent"
                  shape="square"
                  style={{
                    marginTop: "8px",
                  }}
                >
                  {i18n.t<string>("signIn")}
                </Button>
              )}

              <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            </StackShim>

            {/*Benutzereinstellungen*/}
            {props.user && (
              <>
                <TabList
                  onTabSelect={(ev, data) => {
                    if (typeof data.value == "string") {
                      setSelectedTab(data.value);
                      onNavigated(data.value);
                    }
                  }}
                  selectedValue={selectedTab}
                  vertical
                >
                  {links
                    .find((x) => x.name == "UserOptions")
                    ?.links.map((item) => {
                      return (
                        <Tab
                          key={item.key}
                          icon={
                            selectedTab == item.key
                              ? item.iconFilled
                              : item.iconRegular
                          }
                          value={item.key}
                        >
                          {item.name}
                        </Tab>
                      );
                    })}
                </TabList>
                <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
              </>
            )}

            {/*Default Tabs*/}
            <TabList
              onTabSelect={(ev, data) => {
                if (typeof data.value == "string") {
                  setSelectedTab(data.value);
                  onNavigated(data.value);
                }
              }}
              selectedValue={selectedTab}
              vertical
            >
              {links
                .find((x) => x.name == "default")
                ?.links.map((item) => {
                  return (
                    <Tab
                      key={item.key}
                      icon={
                        selectedTab == item.key
                          ? item.iconFilled
                          : item.iconRegular
                      }
                      value={item.key}
                    >
                      {item.name}
                    </Tab>
                  );
                })}
            </TabList>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
          </>
        )}
      </>
      <TabList
        onTabSelect={(ev, data) => {
          if (typeof data.value == "string") {
            setSelectedTab(data.value);
            onNavigated(data.value);
          }
        }}
        selectedValue={selectedTab}
        vertical
      >
        {links
          .find((x) => x.name == "Module")
          ?.links.filter((x) => x.key != "/")
          .map((item) => {
            return (
              <Tab
                key={item.key}
                icon={
                  selectedTab == item.key ? item.iconFilled : item.iconRegular
                }
                value={item.key}
              >
                {item.name}
              </Tab>
            );
          })}
      </TabList>

      <Accordion
        /* multiple */ collapsible
        openItems={[openAccordionItems]}
        onToggle={(ev, data) => {
          if (openAccordionItems == data.value) {
            setOpenAccordionItems("");
          } else {
            setOpenAccordionItems(data.value as string);
          }
        }}
      >
        {links
          .filter(
            (x) =>
              x.name != "Module" &&
              x.name != "default" &&
              x.name != "UserOptions",
          )
          .map((item) => {
            if (props.user) {
              return (
                <AccordionItem value={item.name}>
                  <AccordionHeader>{item.name}</AccordionHeader>
                  <AccordionPanel>
                    <TabList
                      onTabSelect={(ev, data) => {
                        if (typeof data.value == "string") {
                          setSelectedTab(data.value);
                          onNavigated(data.value);
                        }
                      }}
                      selectedValue={selectedTab}
                      vertical
                    >
                      {item.links.map((item) => {
                        if (item.name != i18n.t<string>("homePage")) {
                          return (
                            <Tab
                              key={item.key}
                              icon={
                                selectedTab == item.key
                                  ? item.iconFilled
                                  : item.iconRegular
                              }
                              value={item.key}
                            >
                              {item.name}
                            </Tab>
                          );
                        }
                      })}
                    </TabList>
                  </AccordionPanel>
                </AccordionItem>
              );
            }
          })}
      </Accordion>
    </>
  );
}

export default NavMenu;
